// API-based Client Service for backend integration
import { authApiService } from './authApiService';
import { API_URL } from '../config';

// Helper function to create authenticated headers
const getAuthHeaders = (additionalHeaders = {}) => {
  const token = authApiService.getStoredToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...additionalHeaders
  };
};

export const clientApiService = {
  // Get all clients
  async getAllClients() {
    const res = await fetch(`${API_URL}/clients`, {
      headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Failed to fetch clients');
    return res.json();
  },

  // Add a new client
  async addClient(clientData) {
    const res = await fetch(`${API_URL}/clients`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(clientData)
    });
    if (!res.ok) throw new Error('Failed to add client');
    return res.json();
  },

  // Get a client by ID
  async getClientById(clientId) {
    const res = await fetch(`${API_URL}/clients/${clientId}`, {
      headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Client not found');
    return res.json();
  },

  // Update a client
  async updateClient(clientId, updates) {
    const res = await fetch(`${API_URL}/clients/${clientId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(updates)
    });
    if (!res.ok) throw new Error('Failed to update client');
    return res.json();
  },

  // Delete a client
  async deleteClient(clientId) {
    const res = await fetch(`${API_URL}/clients/${clientId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Failed to delete client');
    return res.json();
  },

  // Search clients by name or phone
  async searchClients(query) {
    const res = await fetch(`${API_URL}/clients?search=${encodeURIComponent(query)}`, {
      headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Failed to search clients');
    return res.json();
  }
};
